// TODO: Check each usage and replace with Optimizely version or remove completely if
// not required. Right now, primarily used for GA4 event
export const useIsFeatureFlagLoaded = () => true;
